function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { AngularFormControllerErrorAdapter, i18n, MetadataActions, MetadataConstants, MetadataSelectors, PermissionService, SessionSelectors } from 'invision-core';
import pathOr from 'ramda/src/pathOr';
import { ApplyCreditErrorSelector, IsApplyingCreditSelector } from '../../../reducers/selectors/customer.convergent.biller.selectors';
import { CurrentCustomerIdSelector } from '../../../reducers/selectors/customer.selectors';
import { applyOrderCredit, clearApplyCreditErrors } from '../../../reducers/actions/order.actions';
import { createPaymentInstrument, redeemGiftCard, retrieveWallet } from '../../../reducers/actions/customer.ewallet.actions';
import { EwalletErrorSelector, PaymentIsFetchingDataSelector } from '../../../reducers/selectors/customer.ewallet.selectors';
import { CanAddPaymentInstruments, CanChangePaymentInstrument, CurrentPaymentInstrumentsTypeSelector, MutablePaymentInstrumentsTypeFilterOptionsSelector } from '../../../reducers/selectors/apply.credit.modal.selectors';
import { NEW_PAYMENT_INSTRUMENT, ORIGINAL_PAYMENT } from './apply.credit.modal.constants';
import { ISSUE_CREDIT_TO_ALTERNATE_PAYMENT_INSTRUMENT, ISSUE_CREDIT_STANDARD_CURRENCY_LIMIT } from '../../../security.attributes';
import { SUPPORTED_PAYMENT_INSTRUMENT_TYPES } from '../ewallet/ewallet.constants';
import { NOTIFICATION_TIME_LENGTH } from '../../../customercare.constants';
import { retrieveCustomerHouseholds } from '../../../reducers/actions/customer.household.actions';
import { FLOAT } from '../../shared/constants/regex.constants';
import { isPaymentSelectable } from '../../customer/ewallet/ewallet.helpers';
import CustomerCareLocaleKeys from '../../../locales/keys';
import { UnvalidatedAddressesSelector, ValidatedAddressesSelector } from '../../../reducers/selectors/address.component.selectors';
import { isAddressValidFromAddressResponse } from '../../shared/contextualComponents/address/address.validator.helper';
import { setForceShowEditFormAddress, validateAddress } from '../../../reducers/actions/address.component.actions';
export var ApplyCreditModalController = /*#__PURE__*/function () {
  function ApplyCreditModalController($filter, $ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, ApplyCreditModalController);
    Object.assign(this, {
      $filter: $filter,
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      uiNotificationService: uiNotificationService
    });
    this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;
    this.creditLocaleKeys = CustomerCareLocaleKeys.ORDER_DETAILS.CREDIT;
    this.currencyRegex = FLOAT;
    this.allowPaymentSelection = true;
    this.isEditingPaymentInstrument = false;
    this.availableCards = [];
    this.NEW_PAYMENT_INSTRUMENT = NEW_PAYMENT_INSTRUMENT;
    this.ORIGINAL_PAYMENT = ORIGINAL_PAYMENT;
    this.MAX_DESCR_LENGTH = 100;
  }
  return _createClass(ApplyCreditModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          areCreditReasonsLoaded: MetadataSelectors.codes.CreditReasonsLoadedSelector(store),
          applyCreditError: ApplyCreditErrorSelector(store),
          canAddPaymentInstruments: CanAddPaymentInstruments(store),
          canChangePaymentInstrument: CanChangePaymentInstrument(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentPaymentInstrumentTypes: CurrentPaymentInstrumentsTypeSelector(store),
          eWalletError: EwalletErrorSelector(store),
          isApplyingCredit: IsApplyingCreditSelector(store),
          isFetchingWallet: PaymentIsFetchingDataSelector(store),
          language: SessionSelectors.LanguageSelector(store),
          reasonsOptions: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.CreditReasons, store),
          paymentInstrumentConfiguration: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.PaymentInstrumentConfiguration, store),
          paymentInstrumentConfigurationLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.PaymentInstrumentConfiguration, store),
          paymentInstrumentsTypeFilterOptions: MutablePaymentInstrumentsTypeFilterOptionsSelector(store),
          paymentInstrumentTypes: CurrentPaymentInstrumentsTypeSelector(store),
          userSecurityAttributes: SessionSelectors.UserSecurityAttributesSelector(store),
          unvalidatedAddresses: UnvalidatedAddressesSelector(store),
          validatedAddresses: ValidatedAddressesSelector(store)
        };
      };
      var controllerActions = {
        fetchCreditReasons: MetadataActions.codes.fetchCreditReasons,
        applyOrderCredit: applyOrderCredit,
        clearApplyCreditErrors: clearApplyCreditErrors,
        createPaymentInstrument: createPaymentInstrument,
        fetchCodeType: MetadataActions.codes.fetchCodeTypes,
        redeemGiftCard: redeemGiftCard,
        retrieveCustomerHouseholds: retrieveCustomerHouseholds,
        retrieveWallet: retrieveWallet,
        setForceShowEditFormAddress: setForceShowEditFormAddress,
        validateAddress: validateAddress
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.areCreditReasonsLoaded) {
        this.actions.fetchCreditReasons();
      }
      if (!this.state.paymentInstrumentConfigurationLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.PaymentInstrumentConfiguration);
      }
      if (this.canChangePaymentInstrument) {
        this.actions.retrieveWallet({
          customerId: this.state.currentCustomerId
        }).then(function () {
          _this.updateAvailablePaymentInstruments();
        });
      }
      this.selectedCard = null;
      this.model = {
        ReasonCode: null,
        Description: null,
        Amount: this.maxCreditAmount,
        AmountType: 'max',
        SendNotification: false
      };
      this.paymentInstrumentRequestObject = {};
      this.updateAvailablePaymentInstruments();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnect();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(_ref) {
      var paymentInstruments = _ref.paymentInstruments;
      if (paymentInstruments) {
        this.updateAvailablePaymentInstruments();
      }
    }
  }, {
    key: "isAmountValid",
    get: function get() {
      var value = parseFloat(this.model.Amount);
      return value > 0 && value <= this.maxCreditAmount;
    }
  }, {
    key: "updateAvailablePaymentInstruments",
    value: function updateAvailablePaymentInstruments() {
      if (this.state && this.state.canChangePaymentInstrument) {
        this.availableCards = Array.from(this.state.paymentInstrumentsTypeFilterOptions);
      } else {
        this.availableCards = [];
      }
      this.availableCards.unshift({
        value: this.ORIGINAL_PAYMENT,
        text: i18n.translate(this.creditLocaleKeys.ORIGINAL_PAYMENT_METHOD)
      });
      this.selectedCard = this.ORIGINAL_PAYMENT;
      this.allowPaymentSelection = true;
      this.updateAllowablePaymentSelection();
    }
  }, {
    key: "canChangePaymentInstrument",
    get: function get() {
      return PermissionService.hasAccess(this.state.userSecurityAttributes, ISSUE_CREDIT_TO_ALTERNATE_PAYMENT_INSTRUMENT);
    }
  }, {
    key: "maxCreditAmount",
    get: function get() {
      return Math.min(this.maxAmount, PermissionService.getUpperLimitAccess(this.state.userSecurityAttributes, ISSUE_CREDIT_STANDARD_CURRENCY_LIMIT.id));
    }
  }, {
    key: "isOriginalPaymentOnly",
    get: function get() {
      return this.selectedCard === this.ORIGINAL_PAYMENT && this.availableCards.length === 1 && this.availableCards[0].value === this.ORIGINAL_PAYMENT;
    }
  }, {
    key: "handleSetAmountType",
    value: function handleSetAmountType() {
      if (this.model.AmountType === 'max') {
        this.model.CustomAmount = undefined;
        this.model.Amount = this.maxCreditAmount;
      } else if (this.model.AmountType === 'custom') {
        this.model.Amount = this.model.CustomAmount || 0;
        this.formController.applyCreditAmount.$setUntouched();
      }
    }
  }, {
    key: "updateCustomAmount",
    value: function updateCustomAmount() {
      if (this.model.AmountType === 'custom') {
        this.model.Amount = this.model.CustomAmount;
      }
    }
  }, {
    key: "updateAllowablePaymentSelection",
    value: function updateAllowablePaymentSelection() {
      var _this2 = this;
      this.paymentInstruments.forEach(function (paymentInstrument) {
        var shouldAllow = isPaymentSelectable(paymentInstrument);
        if (!shouldAllow) {
          _this2.allowPaymentSelection = false;
        }
      });
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var _this3 = this;
      this.$timeout(function () {
        _this3.formErrors = AngularFormControllerErrorAdapter(_this3.formController, {
          applyCreditReason: _this3.creditLocaleKeys.REASON,
          applyCreditDescription: _this3.creditLocaleKeys.DESCRIPTION,
          applyCreditAmount: _this3.creditLocaleKeys.AMOUNT
        }, {
          maxlength: {
            applyCreditDescription: _this3.MAX_DESCR_LENGTH
          }
        });
        if (!_this3.isAmountValid) {
          _this3.formErrors.push(i18n.translate(CustomerCareLocaleKeys.WRITE_OFF.AMOUNT_VALUE_INVALID, {
            minAmount: !_this3.brandableCurrencyName ? _this3.$filter('invCurrency')(0, _this3.currencyCode) : _this3.$filter('invBrandableCurrency')(0, _this3.brandableCurrencyName),
            maxAmount: !_this3.brandableCurrencyName ? _this3.$filter('invCurrency')(_this3.maxCreditAmount, _this3.currencyCode) : _this3.$filter('invBrandableCurrency')(_this3.maxCreditAmount, _this3.brandableCurrencyName)
          }));
        }
      });
    }
  }, {
    key: "applyOrderCredit",
    value: function applyOrderCredit(customerId, details) {
      var _this4 = this;
      this.actions.applyOrderCredit(customerId, details).then(function () {
        _this4.onSubmit()();
      });
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this5 = this;
      this.formErrors = [];
      if (this.formController.$valid && this.isAmountValid) {
        this.validateAddressWithAPI().then(function () {
          var addressKey = _this5.getAddressKey();
          var validatedAddress = _this5.state.validatedAddresses[addressKey];
          if (!addressKey || validatedAddress && isAddressValidFromAddressResponse(validatedAddress)) {
            var _this5$model = _this5.model,
              Description = _this5$model.Description,
              ReasonCode = _this5$model.ReasonCode,
              Amount = _this5$model.Amount,
              SendNotification = _this5$model.SendNotification;
            var creditDetails = Object.assign({
              Description: Description,
              ReasonCode: ReasonCode,
              Amount: Amount,
              SendNotification: SendNotification
            }, _this5.additionalApiData);
            if (_this5.allowPaymentSelection) {
              if (_this5.selectedCard === _this5.NEW_PAYMENT_INSTRUMENT) {
                if (_this5.paymentInstrumentRequestObject.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.INTERNAL_GIFT_CARD) {
                  _this5.actions.redeemGiftCard(_this5.paymentInstrumentRequestObject.Pin, _this5.paymentInstrumentRequestObject.CustomerId).then(function (redeemedGiftCard) {
                    _this5.uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.E_WALLET.REDEEM_GIFT_CARD_SUCCESS), null, {
                      timeOut: NOTIFICATION_TIME_LENGTH
                    });
                    creditDetails.PaymentInstrument = {
                      Id: redeemedGiftCard.Id
                    };
                    _this5.applyOrderCredit(_this5.state.currentCustomerId, creditDetails);
                  });
                } else {
                  _this5.actions.createPaymentInstrument(_this5.paymentInstrumentRequestObject).then(function (createdPaymentInstrument) {
                    _this5.uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.MAKE_PAYMENT.CREATE_INSTRUMENT_SUCCESS), null, {
                      timeOut: NOTIFICATION_TIME_LENGTH
                    });
                    creditDetails.PaymentInstrument = {
                      Id: createdPaymentInstrument.PaymentInstrument.Id
                    };
                    _this5.applyOrderCredit(_this5.state.currentCustomerId, creditDetails);
                  });
                }
              } else {
                creditDetails.PaymentInstrument = {
                  Id: _this5.selectedCard
                };
              }
            }
            if (_this5.selectedCard === _this5.ORIGINAL_PAYMENT) {
              delete creditDetails.PaymentInstrument;
            }
            if (creditDetails.PaymentInstrument && creditDetails.PaymentInstrument.Id || _this5.selectedCard === _this5.ORIGINAL_PAYMENT) {
              _this5.applyOrderCredit(_this5.state.currentCustomerId, creditDetails);
            }
          } else {
            _this5.actions.setForceShowEditFormAddress(false);
            _this5.uiNotificationService.transientError(i18n.translate(_this5.CustomerCareLocaleKeys.ADDRESS_COMPONENT.INVALID_ADDRESS_ERROR_MESSAGE));
          }
        }).catch(function (err) {
          _this5.uiNotificationService.transientError(err.translatedMessage);
        });
      } else {
        this.validateForm();
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.onClose()();
    }

    //check if this works
  }, {
    key: "getAddressKey",
    value: function getAddressKey() {
      return pathOr(undefined, ['formController', 'paymentBillingAddressForm.paymentInstrumentForm', 'addressWrapupController.singleAddressFormFormApi', 'addressKey'], this);
    }
  }, {
    key: "getAddressKeyForAddressValidatedThroughAPI",
    value: function getAddressKeyForAddressValidatedThroughAPI() {
      return pathOr(undefined, ['formController', 'paymentBillingAddressForm.paymentInstrumentForm', 'addressWrapupController.singleAddressFormFormApi', 'keyForAddressValidatedThroughAPI'], this);
    }
  }, {
    key: "getJobToken",
    value: function getJobToken() {
      var addressKey = this.getAddressKey(),
        addressKeyForAddressValidatedThroughAPI = this.getAddressKeyForAddressValidatedThroughAPI(),
        validatedAddressForCurrentAddress = this.state.validatedAddresses[addressKey],
        validatedAddressForAddressValidatedThroughAPI = this.state.validatedAddresses[addressKeyForAddressValidatedThroughAPI];
      if (validatedAddressForCurrentAddress && validatedAddressForCurrentAddress.JobToken) {
        return validatedAddressForCurrentAddress.JobToken;
      } else if (validatedAddressForAddressValidatedThroughAPI && validatedAddressForAddressValidatedThroughAPI.JobToken) {
        return validatedAddressForAddressValidatedThroughAPI.JobToken;
      }
      return null;
    }
  }, {
    key: "validateAddressWithAPI",
    value: function validateAddressWithAPI() {
      //TO-DO verify the appropriate addressType for below
      var addressKey = this.getAddressKey(),
        unvalidatedAddress = this.state.unvalidatedAddresses[addressKey],
        validatedAddress = this.state.validatedAddresses[addressKey],
        addressTypes = {
          DefaultBilling: true,
          DefaultHome: true,
          DefaultPostal: true,
          DefaultService: true
        };
      if (validatedAddress || !unvalidatedAddress) {
        return Promise.resolve(100);
      } else {
        return this.actions.validateAddress(addressKey, unvalidatedAddress, this.getJobToken(), addressTypes);
      }
    }
  }]);
}();
export default {
  template: require('./apply.credit.modal.html'),
  controller: ApplyCreditModalController,
  controllerAs: 'ApplyCreditModal',
  bindings: {
    additionalApiData: '<',
    brandableCurrencyName: '<',
    currencyCode: '@',
    maxAmount: '<',
    paymentInstruments: '<',
    onClose: '&',
    onSubmit: '&',
    title: '@'
  }
};